import Vue from 'vue/dist/vue.min.js';
import store from './store';

const pageiFrameInstance = Vue.component('page-iframe', {
    data: function () {
        return {
        }
    },
    computed: {
        paramData: function () {
            return ({
                GAID: store.state.GAID
            })
        }
    },
    methods: {
        handleIframe() {
            let iframe = this.$el;
            let parentNode = iframe.parentNode;
            let src = this.$el.getAttribute('src');

            window.addEventListener("message", (event) => {
                if (event.origin.includes("3000") || event.origin == "https://badgermeter.my.site.com") {
                    this.$nextTick(() => {
                        sizeIframe(event);
                        postData(event);
                    });
                }
            });

            const postData = (event) => {
                if (iframe.contentWindow) {
                    iframe.contentWindow.postMessage(JSON.stringify(this.paramData), '*');
                } else {
                    iframe.onload = function () {
                        iframe.contentWindow.postMessage(JSON.stringify(this.paramData), '*');
                    }
                }
            }

            const sizeIframe = (event) => {
                if (typeof event.data === 'string') {
                    let data = JSON.parse(event.data);
                    if (data.type == "height") {
                        iframe.style.height = `${data.content}px`;
                        parentNode.style.height = `${data.content + 80}px`;
                        this.checkScroll();
                    }
                }
            };
        },
        checkScroll() {
            let iframe = this.$el;
            let iframePos = iframe.offsetTop;
            let scrollOffset = window.scrollY;

            if (iframePos < scrollOffset) {
                let elmPos = iframe.getBoundingClientRect().top + window.scrollY - 100;
                setTimeout(function () {
                    window.scrollTo({
                        top: (elmPos - 70),
                        behavior: 'smooth'
                    });
                }, 500);
            }
        }
    },
    mounted() {
        this.handleIframe();
    }
});

const pageiFrame = () => {

    let forms = document.querySelectorAll('.page-iframe');

    let formConstructor = (id) => {
        pageiFrameInstance;

        new Vue({
            el: `.page-iframe-${id}`,
        }).$mount(`.page-iframe-${id}`, true);
    }

    if (forms.length > 0) {
        forms.forEach((item, index) => {
            item.classList.add(`page-iframe-${index}`);
            formConstructor(index);
        })
    }
}

export { pageiFrame, pageiFrameInstance };
